import { SENSE_BOOSTER_TAG, QUESTION_RUBRIC_TAG, createTagsForList } from './utils/tags'
import {
    normalizeFetchActiveBoostersResponse,
    normalizeFetchQuestionRubricBoostersResponse,
    normalizeAddBoosterToQuestionRubricResponse,
    normalizeUpdateQuestionRubricBoosterResponse,
} from './utils/normalizers/booster.normalizers'
import baseApi from './base.api'

export const boosterApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        // Fetch all active boosters
        fetchActiveBoosters: builder.query({
            query: () => ({
                url: '/sense-boosters',
                method: 'GET',
                params: { active_only: true },
            }),
            transformResponse: normalizeFetchActiveBoostersResponse,
            providesTags: result => [
                ...createTagsForList(result, SENSE_BOOSTER_TAG),
                { type: SENSE_BOOSTER_TAG, id: 'ACTIVE_LIST' },
            ],
        }),

        // Fetch boosters for a specific question rubric
        fetchQuestionRubricBoosters: builder.query({
            query: ({ questionRubricId }) => ({
                url: `/rubrics/question-rubrics/${questionRubricId}/boosters`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchQuestionRubricBoostersResponse,
            providesTags: (result, error, { questionRubricId }) => [
                ...createTagsForList(result, SENSE_BOOSTER_TAG, 'senseBoosterId'),
                { type: SENSE_BOOSTER_TAG, id: `QUESTION_RUBRIC_${questionRubricId}` },
            ],
        }),

        // Add booster to question rubric
        addBoosterToQuestionRubric: builder.mutation({
            query: ({ questionRubricId, senseBoosterId, priority, enabled = true }) => ({
                url: `/rubrics/question-rubrics/${questionRubricId}/boosters`,
                method: 'POST',
                body: {
                    sense_booster_id: senseBoosterId,
                    priority,
                    enabled,
                },
            }),
            transformResponse: normalizeAddBoosterToQuestionRubricResponse,
            invalidatesTags: (result, error, { questionRubricId }) => [
                { type: SENSE_BOOSTER_TAG, id: `QUESTION_RUBRIC_${questionRubricId}` },
                { type: QUESTION_RUBRIC_TAG, id: questionRubricId },
            ],
        }),

        // Remove booster from question rubric
        removeBoosterFromQuestionRubric: builder.mutation({
            query: ({ questionRubricId, boosterId }) => ({
                url: `/rubrics/question-rubrics/${questionRubricId}/boosters/${boosterId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, { questionRubricId }) => [
                { type: SENSE_BOOSTER_TAG, id: `QUESTION_RUBRIC_${questionRubricId}` },
                { type: QUESTION_RUBRIC_TAG, id: questionRubricId },
            ],
        }),

        // Update question rubric booster priority/enabled
        updateQuestionRubricBooster: builder.mutation({
            query: ({ questionRubricId, boosterId, priority, enabled }) => ({
                url: `/rubrics/question-rubrics/${questionRubricId}/boosters/${boosterId}`,
                method: 'PATCH',
                body: { priority, enabled },
            }),
            transformResponse: normalizeUpdateQuestionRubricBoosterResponse,
            invalidatesTags: (result, error, { questionRubricId }) => [
                { type: SENSE_BOOSTER_TAG, id: `QUESTION_RUBRIC_${questionRubricId}` },
                { type: QUESTION_RUBRIC_TAG, id: questionRubricId },
            ],
        }),
    }),
})

export const {
    useFetchActiveBoostersQuery,
    useFetchQuestionRubricBoostersQuery,
    useAddBoosterToQuestionRubricMutation,
    useRemoveBoosterFromQuestionRubricMutation,
    useUpdateQuestionRubricBoosterMutation,
} = boosterApi